import React from 'react';
import { ProductCard } from '../components/ProductCard';
import { CategoryCard } from '../components/CategoryCard';
import { products, categories } from '../utils/data';
export function Home() {
  const featuredProducts = products.filter(product => product.featured);
  return <div className="w-full bg-gray-50" data-id="element-173">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-green-50 to-green-100" data-id="element-174">
        <div className="container mx-auto px-4 py-16 md:py-24" data-id="element-175">
          <div className="flex flex-col md:flex-row items-center" data-id="element-176">
            <div className="md:w-1/2 mb-8 md:mb-0" data-id="element-177">
              <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4" data-id="element-178">
                Quality Products at{' '}
                <span className="text-green-600" data-id="element-179">Affordable Prices</span>
              </h1>
              <p className="text-lg text-gray-600 mb-6" data-id="element-180">
                Discover premium used electronics and precious metals, carefully
                curated for quality and value.
              </p>
              <div className="flex flex-wrap gap-4" data-id="element-181">
                <a href="#electronics" className="px-6 py-3 bg-green-600 text-white font-medium rounded-full hover:bg-green-700 transition shadow-sm" data-id="element-182">
                  Shop Electronics
                </a>
                <a href="#metals" className="px-6 py-3 bg-white text-green-600 font-medium rounded-full hover:bg-gray-100 transition border border-green-600" data-id="element-183">
                  Shop Precious Metals
                </a>
              </div>
            </div>
            <div className="md:w-1/2 flex justify-center" data-id="element-184">
              <img src="https://images.unsplash.com/photo-1603539947678-cd3954ed515d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80" alt="Electronics and Precious Metals Collection" className="rounded-lg shadow-lg max-w-full h-auto" data-id="element-185" />
            </div>
          </div>
        </div>
      </section>
      {/* Featured Products */}
      <section className="py-12 md:py-16" data-id="element-186">
        <div className="container mx-auto px-4" data-id="element-187">
          <h2 className="text-3xl font-bold text-gray-800 mb-2" data-id="element-188">
            Featured Products
          </h2>
          <p className="text-gray-600 mb-8" data-id="element-189">
            Our handpicked selection of quality items
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6" data-id="element-190">
            {featuredProducts.map(product => <ProductCard key={product.id} product={product} data-id="element-191" />)}
          </div>
        </div>
      </section>
      {/* Categories */}
      <section className="py-12 md:py-16 bg-white" id="categories" data-id="element-192">
        <div className="container mx-auto px-4" data-id="element-193">
          <h2 className="text-3xl font-bold text-gray-800 mb-2" data-id="element-194">
            Browse Categories
          </h2>
          <p className="text-gray-600 mb-8" data-id="element-195">
            Find exactly what you're looking for
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6" data-id="element-196">
            {categories.map(category => <CategoryCard key={category.id} title={category.title} image={category.image} count={category.count} link={`/#${category.id}`} data-id="element-197" />)}
          </div>
        </div>
      </section>
      {/* Electronics Section */}
      <section className="py-12 md:py-16" id="electronics" data-id="element-198">
        <div className="container mx-auto px-4" data-id="element-199">
          <h2 className="text-3xl font-bold text-gray-800 mb-2" data-id="element-200">
            Used Electronics
          </h2>
          <p className="text-gray-600 mb-8" data-id="element-201">
            Quality tested and guaranteed to work
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6" data-id="element-202">
            {products.filter(product => product.category === 'electronics').map(product => <ProductCard key={product.id} product={product} data-id="element-203" />)}
          </div>
        </div>
      </section>
      {/* Precious Metals Section */}
      <section className="py-12 md:py-16 bg-white" id="metals" data-id="element-204">
        <div className="container mx-auto px-4" data-id="element-205">
          <h2 className="text-3xl font-bold text-gray-800 mb-2" data-id="element-206">
            Precious Metals
          </h2>
          <p className="text-gray-600 mb-8" data-id="element-207">
            Investment-grade metals at competitive prices
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6" data-id="element-208">
            {products.filter(product => product.category === 'metals').map(product => <ProductCard key={product.id} product={product} data-id="element-209" />)}
          </div>
        </div>
      </section>
      {/* Value Proposition */}
      <section className="py-12 md:py-16 bg-green-50" data-id="element-210">
        <div className="container mx-auto px-4" data-id="element-211">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-212">
            <div className="text-center p-6" data-id="element-213">
              <div className="bg-white w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4 shadow-sm" data-id="element-214">
                <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-215">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" data-id="element-216" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-2" data-id="element-217">
                Quality Guaranteed
              </h3>
              <p className="text-gray-600" data-id="element-218">
                Every item is thoroughly inspected and tested before listing.
              </p>
            </div>
            <div className="text-center p-6" data-id="element-219">
              <div className="bg-white w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4 shadow-sm" data-id="element-220">
                <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-221">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" data-id="element-222" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-2" data-id="element-223">
                Best Value
              </h3>
              <p className="text-gray-600" data-id="element-224">
                Competitive pricing on all our products with no hidden fees.
              </p>
            </div>
            <div className="text-center p-6" data-id="element-225">
              <div className="bg-white w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4 shadow-sm" data-id="element-226">
                <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-227">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-228" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-2" data-id="element-229">
                Easy Returns
              </h3>
              <p className="text-gray-600" data-id="element-230">
                Not satisfied? Return within 30 days for a full refund.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>;
}